import type { AnchorId, BaseId, GuideId, RingId, SpaceId, TbcId, TopId } from '@kinnet-studio/pattern';

// Ids the SP-125 converter derives from a stored stitch array's id. The first
// three are the renderer's own synthetic instance ids (`arrayInstanceViewModel`),
// so a stitch exploded from instance `i` keeps the id its view model always had.
// Existing ids are prefixed uuids, so a derived id (it contains ':') can't
// collide with one.

/** The stitch exploded from instance `i`. */
export const legacyStitchId = (arrayId: string, i: number): TbcId => `${arrayId}:${i}`;
/** That stitch's single base. */
export const legacyBaseId = (arrayId: string, i: number): BaseId => `${arrayId}:b${i}`;
/** That stitch's single top. */
export const legacyTopId = (arrayId: string, i: number): TopId => `${arrayId}:t${i}`;

/** The Space made for an array that bases were worked into. */
export const legacySpaceId = (arrayId: string): SpaceId => `${arrayId}:space`;
/** That Space's target guide. */
export const legacySpaceGuideId = (arrayId: string): GuideId => `${arrayId}:space-guide`;
/** The single ring of that guide (circle and arc arrays). */
export const legacySpaceRingId = (arrayId: string): RingId => `${arrayId}:space-ring`;
/** Anchor `k` of that guide (bezier arrays). */
export const legacySpaceAnchorId = (arrayId: string, k: number): AnchorId => `${arrayId}:space-guide:a${k}`;
